import { render } from "./UCSupplementaryData.vue?vue&type=template&id=67580ae0"
import script from "./UCSupplementaryData.vue?vue&type=script&lang=js"
export * from "./UCSupplementaryData.vue?vue&type=script&lang=js"

import "./UCSupplementaryData.vue?vue&type=style&index=0&id=67580ae0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__